import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import AddItemsFormField from '../../common/components/AddItemsFormField';
import settingsSelectors from '../settingsSelector';
import { loadGroups, updateGroups } from '../settingsReducer';
import { AppDispatch } from '../../store';
import { Setting } from '../../common/types/settings';
import groupForm from '../fbSettings/groupForm';

function GroupsSettings() {
  const dispatch: AppDispatch = useDispatch();
  const groups = useSelector(settingsSelectors.getGroups);

  React.useEffect(() => {
    dispatch(loadGroups());
  }, []);

  return (
    <AddItemsFormField
      key='groups'
      expanded
      items={groups}
      form={groupForm}
      renderItemEntry={(item: Setting) => (
        <Stack flex={1} direction='row' spacing={2} justifyContent='flex-start'>
          <Typography>{item.value}</Typography>
        </Stack>
      )}
      updateItem={async (updatedItem) => {
        const isNewGroup = groups.find((group) => group.id === updatedItem.id) === undefined;

        const newGroups = isNewGroup
          ? groups.concat([updatedItem])
          : groups.map((group) => {
              if (group.id === updatedItem.id) {
                return updatedItem;
              }
              return group;
            });
        await dispatch(updateGroups(newGroups));
        await dispatch(loadGroups());
      }}
      deleteItem={async (updatedItem) => {
        const newGroup = groups.filter((group) => group.id !== updatedItem.id);
        await dispatch(updateGroups(newGroup));
        await dispatch(loadGroups());
      }}
    />
  );
}

export default GroupsSettings;
